import { forwardRef } from 'react';

import { SwitchProps } from '@mui/material';

import { SSwitch } from './styled';

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => (
  <SSwitch {...props} ref={ref} disableRipple />
));
